import { render } from "./SectionDivider.vue?vue&type=template&id=1b77d53b"
const script = {}

import exportComponent from "/var/www/dental/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__